import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as affiliate from '../affiliate'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: affiliate.RESOURCE.payload.dimension.partialId,
      partialId: affiliate.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Region that this affiliate serves',
    isOptional: true,
    name: 'Service Region',
    partialId: PartialId.Standard.create('service_region'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
